
"use client";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function Subheader({ title, description }) {
  const YOUTUBE_ID = "Z0Ap6ENEbXk";
  const YOUTUBE_URL = `https://www.youtube.com/watch?v=${YOUTUBE_ID}`;
  const THUMBNAIL = `https://img.youtube.com/vi/${YOUTUBE_ID}/maxresdefault.jpg`;

  const [showVideo, setShowVideo] = useState(false);

  // Delay video load slightly for smoother UX
  useEffect(() => {
    const t = setTimeout(() => setShowVideo(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 -z-10 overflow-hidden">

        {!showVideo && (
          <div className="absolute inset-0 -z-10">
            <Image
              src={THUMBNAIL}
              alt="Video thumbnail"
              fill
              priority
              className="object-cover"
            />

            <div className="absolute inset-0 bg-black/40" />
          </div>
        )}

        {showVideo && (
          <div className="absolute inset-0">
            <div
              className="
                absolute top-1/2 left-1/2
                w-[177.78vh] h-[100vh]
                min-w-[100vw] min-h-[56.25vw]
                -translate-x-1/2 -translate-y-1/2
              "
            >
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&mute=1&loop=1&playlist=${YOUTUBE_ID}&controls=0&showinfo=0&modestbranding=1&rel=0`}
                className="absolute inset-0 w-full h-full"
                allow="autoplay; encrypted-media"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </div>
        )}

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto">
        <div className="flex min-h-80 md:min-h-105 lg:min-h-95 items-center">
          <div className="w-full py-10 md:py-16 lg:py-20">
            <div className="max-w-xl">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight">
                {title}
              </h1>
              <p className="mt-3 font-medium text-white/90 leading-relaxed">
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ================= CTA ================= */}
      <div className="absolute inset-x-0 bottom-6">
        <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto">
          <div className="flex justify-end">
            <a
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[11px] sm:text-xs md:text-sm font-semibold tracking-[0.18em] uppercase text-white/90 hover:text-white"
            >
              View Video
              <svg
                className="h-3 w-3 md:h-4 md:w-4"
                viewBox="0 0 18 18"
                fill="none"
              >
                <circle
                  cx="9"
                  cy="9"
                  r="8"
                  stroke="currentColor"
                  strokeWidth="1.4"
                />
                <path
                  d="M7.2 6.4v5.2L11.2 9 7.2 6.4Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
